import queryString from 'query-string';
import useRouter from './useRouter';

export default function useCurrentPage() {
  const { location } = useRouter();

  const query = queryString.parse(location.search);
  const currentPage = Number(query.page || '1');
  return currentPage;
}
